import { render, staticRenderFns } from "./ReportedListings.vue?vue&type=template&id=2d788247&scoped=true&"
import script from "./ReportedListings.vue?vue&type=script&lang=js&"
export * from "./ReportedListings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d788247",
  null
  
)

export default component.exports